<script lang="ts">
    import { getContext } from "svelte";
    import ActionBarButton from "../ActionBarButton.svelte";
    import { analyticsClient } from "../../../Administration/AnalyticsClient";
    import LoginIcon from "../../Icons/meta/LoginIcon.svelte";
    import LL from "../../../../i18n/i18n-svelte";

    interface Props {
        first?: boolean;
        last?: boolean;
        classList?: string;
    }

    let { first = undefined, last = undefined, classList = undefined }: Props = $props();
    const inProfileMenu = getContext("profileMenu");

    function goToLogin() {
        analyticsClient.login();
        window.location.href = "/login";
    }
</script>

<ActionBarButton
    state="active"
    onclick={goToLogin}
    {first}
    {last}
    {classList}
    title={$LL.menu.profile.login()}
    label={inProfileMenu ? $LL.menu.profile.login() : undefined}
    ariaLabel={$LL.menu.profile.login()}
    dataTestId="login"
>
    <LoginIcon />
</ActionBarButton>
